export let NAVIGATION_ARROWS_BEHAVIOR;
(function (NAVIGATION_ARROWS_BEHAVIOR) {
  NAVIGATION_ARROWS_BEHAVIOR[NAVIGATION_ARROWS_BEHAVIOR["ON_HOVER"] = 0] = "ON_HOVER";
  NAVIGATION_ARROWS_BEHAVIOR[NAVIGATION_ARROWS_BEHAVIOR["ALWAYS"] = 1] = "ALWAYS";
})(NAVIGATION_ARROWS_BEHAVIOR || (NAVIGATION_ARROWS_BEHAVIOR = {}));
//# sourceMappingURL=navigation-arrows-behavior.js.map